<template>
  <el-dialog :title="$t('slb.text.deleteListener')" :visible.sync="openStatus" @close="doClose"
             :close-on-click-modal="false" class="delete-listener-dialog">
    <el-alert type="warning" :title="$t('slb.sentence.deleteInfo')" show-icon :closable="false"></el-alert>
    <span class="delete-tip">{{$t('slb.sentence.delete', [params.name])}}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
      <el-button @click="doConfirm" type="primary">{{ $t('detail.text.sure') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: 'Delete',
    props: {
      dialogVisible: {
        type: Boolean,
        default: false
      },
      params: {
        type: Object,
        default: {}
      },
      type: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        openStatus: false,
      }
    },
    methods: {
      doClose() {
        this.$emit('ifDialogVisible', false);
      },
      cancelBind() {
        this.handleClose();
      },
      doConfirm() {
        const param = {
          region: this.params.region,
          listenerId: this.params.listenerId,
        };
        Ajax.del('/api/cps/listeners', param)
          .then(() => {
            this.doClose();
            this.$message.success(this.$t('subnet.text.operationSuccess'));
            this.$emit('refreshList');
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              this.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          })
      },
    },
    watch: {
      dialogVisible(val) {
        this.openStatus = val;
      }
    },
    created() {
    }
  };
</script>

<style lang="scss">
  @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/slb/detail/listener/delete/Delete.vue